import React from 'react';
import { MatchStatisticsDetail, IMatchStatisticsDetail } from '@sky-it-livedata/livedata-sports-design-system';
import { matchStatisticsWidget } from '@sky-it-livedata/livedata-live-match-pages-widgets';

import { IModelWrapper } from '../../typings/common-types';
import { useService } from '../hooks/useService';
import { isEmptyObject, getModelFromUseService } from '../../utils/props-validator';

export interface IMatchStatisticsDetailWrapper extends IModelWrapper<IMatchStatisticsDetail> {}

const MatchStatisticsDetailWrapper = ({ query, initialModel, live }: IMatchStatisticsDetailWrapper) => {
  const { model } = useService({
    live,
    query,
    widget: matchStatisticsWidget,
    initialValue: initialModel,
  });
  const componentModel: IMatchStatisticsDetail = getModelFromUseService(model);
  return !isEmptyObject(componentModel) ? <div>{<MatchStatisticsDetail {...componentModel} />}</div> : null;
};

export default MatchStatisticsDetailWrapper;
